import React from 'react';
import { observer } from 'mobx-react';
import {
  StackLayout, Button, Modal, useModalStore
} from '@wemogy/reactbase';
import IAddAutocompleteModalProps from './IAddAutocompleteModalProps';
import useDataAccessStore from '../../../../../dataLayer/stores/hooks/UseDataAccessStore';
import AnnotatedFormView from '../../containers/formElements/annotatedFormView/AnnotatedFormView';
import RestApiServiceFactory from '../../../../../dataLayer/api/rest/RestApiServiceFactory';
import NotificationManager from '../../../inAppFeedback/NotificationManager';

const AddAutocompleteModal: React.FC<IAddAutocompleteModalProps> = () => {
  const {formStore} = useDataAccessStore();
  const modalStore = useModalStore();


  const { activeItem } = formStore;
  if(!activeItem){
    return null;
  }

  const canImport = true;

  return (
    <Modal modalKey="importAutocomplete" icon="cloudUpload" title="Autocomplete Daten importieren" large>
      <StackLayout>
        <AnnotatedFormView description="Datendatei" marginBottom>
          <form id="AddAutocompleteModalForm">
            <input accept=".csv" name="file" type="file" />
          </form>
        </AnnotatedFormView>
        <StackLayout hEnd marginTop height={4}>
          {
            canImport ? (
              <Button onPress={(): void => {

                const form: any = document.getElementById('AddAutocompleteModalForm');
                if (!form) {
                  return;
                }
                const fd = new FormData(form);

                (async (): Promise<void> => {
                  try {
                    modalStore.openModal('loadingOverlay', 'Importiere die Daten, dies kann ein wenig Zeit in Anspruch nehmen');
                    const response = await RestApiServiceFactory.dataStructureTemplateService.importCsv(activeItem.id, fd);
                    if (response.ok) {
                      NotificationManager.success('Import erfolgreich abgeschlossen.');
                    }
                    else {
                      NotificationManager.error(`Beim Import ist etwas schief gelaufen. Statuscode: ${response.status}`);
                    }
                  } catch {
                    //
                  }
                  finally {
                    modalStore.closeModal();
                  }
                })();

              }}
              >
                Importieren
              </Button>
            ) : null
          }
        </StackLayout>

      </StackLayout>
    </Modal>
  );
};

export default observer(AddAutocompleteModal);
